import React from "react";

const ArrowRightIcon = ({ className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 19 20"
      className={className ? className : "w-[19px] h-[20px]"}
      {...rest}
    >
      <g clipPath="url(#clip0_5624_57182)">
        <path
          fill="currentColor"
          d="m18.663 9.267-6.809-6.81a1.02 1.02 0 0 0-.73-.3c-.276 0-.535.106-.73.3l-.618.619a1.045 1.045 0 0 0 0 1.468l3.973 3.98H1.128C.559 8.525.109 8.97.109 9.54v.875c0 .569.45 1.06 1.019 1.06h12.666l-4.018 4.003a1 1 0 0 0-.3.723c0 .276.106.532.3.726l.619.616c.194.194.453.3.73.3s.535-.107.73-.301l6.808-6.81c.195-.194.302-.455.302-.731 0-.278-.107-.539-.302-.733"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_5624_57182">
          <path fill="currentColor" d="M.11.572h18.854v18.855H.11z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArrowRightIcon;
